import numbro from "numbro";

export const formatLargeAmount = (amount: number | string) => {
  return numbro(amount)
    .format({
      thousandSeparated: true,
      mantissa: 2,
      trimMantissa: true,
      average: true,
    })
    .toUpperCase();
};
